/* eslint-disable no-undef */
import React from "react";
import "../../styles/SimpleQuizz/OngletQuestion.css";
import { QuizData } from "../../data/quizzData";

// Composant qui affiche le menu des questions

export const OngletQuestion = ({ questionId, setProgression }) => {
  return (
    <div className="cadre">
      {QuizData.map((object) => {
        return (
          // object.theme donne "Approche environementale" on veut juste le mot "environemmentale" utilisé dans le style css"
          <button
            key={object.id}
            title={object.petale}
            className={`button_size_${object.theme.split(" ")[1]} ${
              questionId === object.id ? `selected` : null
            }`}
            onClick={() => setProgression(object.id)}
          >
            <img
              src={
                process.env.PUBLIC_URL + `IconesDeLaFleur/${object.petale}.png`
              }
            ></img>
          </button>
        );
      })}
    </div>
  );
};
